import React, { useEffect, useState } from "react";
import { Button, Col, Row, FormGroup, CustomInput } from "reactstrap";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../baseurl";
import axios from "axios";
import { Link } from "react-router-dom";
import { GetIp } from "./Get_ip";
import ResponseLoader from "./ResponseLoader";
import { csvFileToArray } from "../../Features/Imports/data";
import moment from "moment";
import custmoerSheet from "../../Features/Imports/assets/customerSheet.xlsx";
import { checkPermission } from "../../../Helper";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

export default function ExcelLoad() {
  const username = localStorage.getItem("username");
  const token = localStorage.getItem("token");
  const companyId = localStorage.getItem("companyId");

  const [loadingResponse, setLoadingResponse] = useState(false);
  const [goodRows, setGoodRows] = useState([]);
  const [badRows, setBadRows] = useState([]);
  const [showBadRows, setShowBadRows] = useState(false);
  const [file, setFile] = useState(null);
  const [disableField, setDisableField] = useState(true);
  const [ipCountry, setIpCountry] = useState({ userIp: "", userCountry: "" });
  const [percentageLoader, setPercentageLoader] = useState(false);
  const [showQty, setShowQty] = useState(false);

  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(1);
    getIpCountry();
  }, []);

  const asyncRollCheck = async (value) => {
    let pathname = "/clientExcelLoad";
    let status = value;
    return await checkPermission(pathname, status);
  };

  const handleOnChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleOnChangeFile = async () => {
    if (!file) {
      swal({
        title: "File Not Selected!",
        text: "Please Select File",
        icon: "warning",
      });
      return;
    }

    try {
      setLoadingResponse(true);
      const jsonData = await csvFileToArray(file);
      const nonEmptyArrays = jsonData.filter((arr) => arr.length > 0);

      if (nonEmptyArrays.length === 0) {
        throw new Error("The file contains no valid data");
      }

      const keys = nonEmptyArrays[0];
      const dataObjects = nonEmptyArrays.slice(1).map((row) => {
        const obj = {};
        keys.forEach((key, index) => {
          obj[key] = row[index];
        });
        return obj;
      });

      setDisableField(false);
      await verifyExcelData(dataObjects);
    } catch (error) {
      setLoadingResponse(false);
      console.error(error);
      swal({
        title: "Error",
        text: error.message || "Failed to process file",
        icon: "error",
      });
    }
  };

  const verifyExcelData = async (data) => {
    if (!data || data.length === 0) {
      swal({
        title: "Error",
        text: "No data to verify",
        icon: "error",
      });
      return;
    }

    setPercentageLoader(true);
    const currentDate = new Date();
    const date = moment(currentDate).format("YYYY-MM-DD");

    try {
      const { userIp, userCountry } = ipCountry;

      const response = await axios.post(
        `${baseurl}/pointOfSale/verifyClientExcelData`,
        {
          companyId,
          excelData: data,
          date,
          username,
          userIp,
          userCountry,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );

      const responseData = response.data.data || [];
      const isInvalidValue = (value) => {
        return (
          value === null ||
          value === undefined ||
          value === "" ||
          value === "Invalid"
        );
      };

      const groupedGoodRows = responseData
        .map((item, index) => {
          const masterResult = item || {};
          const inputMaster = data[index] || {};
          // Zeenat only: the category has a prefix, so the backend already
          // computed the real code/name for this row (sequential across the
          // sheet) -- use those instead of whatever's in the raw columns.
          // Every other row (no prefix set) falls back to the typed values,
          // unchanged from before this feature.
          const effectiveCode = masterResult.generatedCode || inputMaster.code;
          const effectiveName =
            masterResult.generatedName || inputMaster.customer;

          const isMasterDataValid = !isInvalidValue(inputMaster.customer_type);
          const isCustValid =
            masterResult.cust_id !== null &&
            masterResult.cust_id !== "more than one";
          const hasValidCustomer = !isInvalidValue(effectiveName);
          const hasValidCode = !isInvalidValue(effectiveCode);
          const hasValidEmail = !isInvalidValue(inputMaster.email);

          const masterValid =
            isMasterDataValid &&
            isCustValid &&
            hasValidCustomer &&
            hasValidCode &&
            hasValidEmail;

          if (!masterValid) return null;

          return {
            customer_type: inputMaster.customer_type || "Invalid",
            customer: effectiveName || "Invalid",
            code: effectiveCode || "Invalid",
            first_name: inputMaster.first_name,
            last_name: inputMaster.last_name,
            address_1: inputMaster.address_1,
            address_2: inputMaster.address_2,
            email: inputMaster.email || "Invalid",
            phone_no: inputMaster.phone_no,
            sales_tax: inputMaster.sales_tax,
            license_no: inputMaster.license_no,
            city: inputMaster.city,
            country: inputMaster.country,
            ship_address_1: inputMaster.ship_address_1,
            ship_address_2: inputMaster.ship_address_2,
            ship_email: inputMaster.ship_email,
            ship_phone_no: inputMaster.ship_phone_no,
            ship_sales_tax: inputMaster.ship_sales_tax,
            ship_city: inputMaster.ship_city,
            ship_country: inputMaster.ship_country,
            stax_regno: inputMaster.stax_regno,
            ntax_no: inputMaster.ntax_no,
            cnic: inputMaster.cnic,
            cust_type_id: masterResult.cust_id || "Invalid",
          };
        })
        .filter(Boolean);

      const groupedBadRows = responseData
        .map((item, index) => {
          const masterResult = item || {};
          const inputMaster = data[index] || {};
          const effectiveCode = masterResult.generatedCode || inputMaster.code;
          const effectiveName =
            masterResult.generatedName || inputMaster.customer;

          const isMasterDataValid = !isInvalidValue(inputMaster.customer_type);
          const isCustValid =
            masterResult.cust_id !== null &&
            masterResult.cust_id !== "more than one";
          const hasValidCustomer = !isInvalidValue(effectiveName);
          const hasValidCode = !isInvalidValue(effectiveCode);
          const hasValidEmail = !isInvalidValue(inputMaster.email);

          const masterValid =
            isMasterDataValid &&
            isCustValid &&
            hasValidCustomer &&
            hasValidCode &&
            hasValidEmail;

          if (masterValid) return null;

          return {
            ...inputMaster,
            customer_type: inputMaster.customer_type || "Invalid",
            customer: effectiveName || "Invalid",
            code: effectiveCode || "Invalid",
            first_name: inputMaster.first_name,
            last_name: inputMaster.last_name,
            address_1: inputMaster.address_1,
            address_2: inputMaster.address_2,
            email: inputMaster.email || "Invalid",
            phone_no: inputMaster.phone_no,
            sales_tax: inputMaster.sales_tax,
            license_no: inputMaster.license_no,
            city: inputMaster.city,
            country: inputMaster.country,
            ship_address_1: inputMaster.ship_address_1,
            ship_address_2: inputMaster.ship_address_2,
            ship_email: inputMaster.ship_email,
            ship_phone_no: inputMaster.ship_phone_no,
            ship_sales_tax: inputMaster.ship_sales_tax,
            ship_city: inputMaster.ship_city,
            ship_country: inputMaster.ship_country,
            stax_regno: inputMaster.stax_regno,
            ntax_no: inputMaster.ntax_no,
            cnic: inputMaster.cnic,
            cust_type_id: masterResult.cust_id || "Invalid",
            isInvalidCust_id: !isCustValid,
            isInvalidName: !hasValidCustomer,
            isInvalidCode: !hasValidCode,
            isInvalidEmail: !hasValidEmail,
            isInvalidCustType: !isMasterDataValid,
          };
        })
        .filter(Boolean);

      setLoadingResponse(false);
      setPercentageLoader(false);
      setGoodRows(groupedGoodRows);
      setBadRows(groupedBadRows);
      setShowQty(true);

      swal({
        title: "Done",
        text: `Excel verification completed. ${groupedGoodRows.length} valid rows, ${groupedBadRows.length} invalid rows.`,
        icon: "success",
      });
    } catch (error) {
      console.error("Error in verifyExcelData:", error);
      setLoadingResponse(false);
      setPercentageLoader(false);

      swal({
        title: "Error",
        text:
          error.response?.data?.message ||
          "Something went wrong, try to refresh the page and try again.",
        icon: "error",
      });
    }
  };

  const getIpCountry = async () => {
    try {
      const res = await GetIp();
      setIpCountry({ userIp: res.ip, userCountry: res.country });
    } catch (error) {
      console.error("Error getting IP country:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const currentDate = new Date();
    const date = moment(currentDate).format("DD-MM-YYYY");

    if (goodRows.length === 0) return;

    setLoadingResponse(true);
    try {
      const { userIp, userCountry } = ipCountry;
      await axios.post(
        `${baseurl}/pointOfSale/addImportCustomerData`,
        {
          companyId,
          customer: goodRows,
          username,
          userIp,
          userCountry,
          date,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );

      setLoadingResponse(false);
      swal({
        title: "Saved Successfully!",
        text: "Item Customer Added",
        icon: "success",
      });
      Redirect("/OverviewClient");
    } catch (error) {
      console.error("Error:", error);
      setLoadingResponse(false);
      swal({
        title: "Error",
        text: "Something went wrong, try to refresh the page and try again.",
        icon: "error",
      });
    }
  };

  const headers = [
    "Customer Type",
    "Customer",
    "Code",
    "First Name",
    "Last Name",
    "Address-1",
    "Address-2",
    "Email",
    "Phone No",
    "Sales Tax No",
    "License No",
    "City",
    "Country",
    "Ship Address-1",
    "Ship Address-2",
    "Ship Email",
    "Ship Phone No",
    "Ship SaleTax",
    "Ship City",
    "Ship Country",
    "Stax Reg No",
    "NTax No",
    "CNIC",
    "Customer Type ID",
  ];

  return (
    <>
      {loadingResponse || percentageLoader ? (
        <ResponseLoader percentage={percentageLoader} />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col xs="6" className="card-header-Creative-Invoice">
              <strong>
                <h4>Import Customer Sheet</h4>
              </strong>
            </Col>
            <Col xs="6" className="card-header-Creative-Invoice">
              <div style={{ textAlign: "right" }}>
                <Link
                  to="/OverviewClient"
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>
          <div className="mt-3">
            <div className="row">
              <div className="col-4 mt-1">
                <a href={custmoerSheet} download>
                  Download example CSV
                </a>
              </div>
            </div>
            <FormGroup>
              <div className="row">
                <div className="col-11">
                  <CustomInput
                    type="file"
                    id="exampleCustomFileBrowser"
                    name="customFile"
                    accept=".csv,.xlsx"
                    required
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-1">
                  <span className="d-flex flex-row-reverse">
                    <Button
                      className="mr-1 btn-outline-primary"
                      onClick={handleOnChangeFile}
                    >
                      Import
                    </Button>
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-3">
                  <Button
                    hidden={goodRows.length === 0 && badRows.length === 0}
                    className={`mr-1 mt-1 ${
                      showBadRows ? "btn-outline-success" : "btn-outline-danger"
                    }`}
                    onClick={() => setShowBadRows(!showBadRows)}
                  >
                    Show {showBadRows ? "Good" : "Bad"} Rows
                  </Button>
                </div>
                {showQty && (
                  <div className="col-4 mt-2">
                    <span style={{ color: "green" }}>
                      No of Good Rows: {goodRows.length}
                    </span>
                    &nbsp;
                    <span style={{ color: "red" }}>
                      No of Bad Rows: {badRows.length}
                    </span>
                  </div>
                )}
              </div>
            </FormGroup>

            <div style={{ overflowX: "auto" }}>
              <table className="table">
                <thead>
                  {showQty && (
                    <tr>
                      {headers.map((header, index) => (
                        <th style={{ border: "1px solid black" }} key={index}>
                          {header}
                        </th>
                      ))}
                    </tr>
                  )}
                </thead>
                <tbody>
                  {(showBadRows ? badRows : goodRows).map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td
                        style={{
                          backgroundColor:
                            row.cust_type_id === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.customer_type}
                      </td>

                      <td
                        style={{
                          backgroundColor:
                            row.customer === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.customer}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.code === "Invalid" ? "#FF0000" : "transparent",
                        }}
                      >
                        {row.code}
                      </td>
                      <td>{row.first_name}</td>
                      <td>{row.last_name}</td>
                      <td>{row.address_1}</td>
                      <td>{row.address_2}</td>
                      <td
                        style={{
                          backgroundColor:
                            row.email === "Invalid" ? "#FF0000" : "transparent",
                        }}
                      >
                        {row.email}
                      </td>
                      <td>{row.phone_no}</td>
                      <td>{row.sales_tax}</td>
                      <td>{row.license_no}</td>
                      <td>{row.city}</td>
                      <td>{row.country}</td>
                      <td>{row.ship_address_1}</td>
                      <td>{row.ship_address_2}</td>
                      <td>{row.ship_email}</td>
                      <td>{row.ship_phone_no}</td>
                      <td>{row.ship_sales_tax}</td>
                      <td>{row.ship_city}</td>
                      <td>{row.ship_country}</td>
                      <td>{row.stax_regno}</td>
                      <td>{row.ntax_no}</td>
                      <td>{row.cnic}</td>
                      <td
                        style={{
                          backgroundColor:
                            row.cust_type_id === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.cust_type_id}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <hr
              style={{
                border: "1px solid",
                marginBottom: "3vh",
                marginTop: "1vh",
                borderColor: "#E4E5E6",
              }}
            />
            <div className="col-md-12 d-flex flex-row-reverse">
              <FormGroup>
                <Button
                  onClick={handleSubmit}
                  className="mr-1 invoiceSubmitButton"
                  disabled={goodRows.length === 0}
                >
                  Save Changes
                </Button>
                <Link to={{ pathname: "/OverviewClient" }}>
                  <Button className="mr-1" size="sm">
                    Cancel
                  </Button>
                </Link>
              </FormGroup>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
